<div class="h-full flex flex-col bg-neutral-3 rounded-2xl p-4">
  <div class="py-2 px-6 mb-6 flex items-center justify-between">
    <h2 class="text-4xl font-bold">Photo Prices</h2>
    <div class="flex gap-2">
      @if (!isEditing()) {
        <button
          (click)="startEdit()"
          class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          Edit
        </button>
      } @else {
        <button
          (click)="saveChanges()"
          [disabled]="saving()"
          class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ saving() ? 'Saving…' : 'Save' }}
        </button>
        <button
          (click)="cancelEdit()"
          [disabled]="saving()"
          class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
      }
    </div>
  </div>

  <div class="flex-1 overflow-auto">
    @if (loading()) {
      <div class="p-4 text-center text-gray-500">Loading prices...</div>
    } @else {
      <div class="flex flex-col gap-2">
        @if (displaySizes().length === 0) {
          <div class="p-4 text-center text-gray-500">No pricing data available.</div>
        } @else {
          @for (size of displaySizes(); track size.width + 'x' + size.height; let i = $index) {
            <app-size-price
              [size]="size"
              [promotion]="getActivePromotionForSize(size)"
              [isEditing]="isEditing()"
              [index]="i"
              (sizeChange)="onSizeChange(i, $event)"
              (remove)="removeSize($event)"
              (promotionClick)="onPromotionClick($event)"
            />
          }
        }
      </div>

      @if (isEditing()) {
        <div class="py-4 flex justify-center">
          <button
            (click)="addSize()"
            class="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
            title="Add new size"
          >
            + Add size
          </button>
        </div>
      }
    }
  </div>
</div>

<!-- Promotion overlay -->
@if (showPromotion() && selectedSize()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50" (click)="closePromotion()"></div>
    
    <!-- Modal content -->
    <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 max-h-screen overflow-y-auto">
      <!-- Close button -->
      <button
        type="button"
        (click)="closePromotion()"
        class="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
      
      <!-- Promotion component -->
      <app-promotion 
        [size]="selectedSize()!" 
        [currentPromotion]="getActivePromotionForSize(selectedSize()!)"
        (promotionSaved)="onPromotionSaved($event)"
        (promotionDeleted)="onPromotionDeleted($event)"
      ></app-promotion>
    </div>
  </div>
}